import { memo } from 'react';
import { View } from 'react-native';
import Animated from 'react-native-reanimated';
import { BoxVariantProps } from '../Box.types';
import useStyle from '../../../hooks/useStyle';

function BoxDefault({
  id,
  animatedStyle,
  entering,
  exiting,
  children,
  onLayout,
  renderToHardwareTextureAndroid,
  ...rest
}: BoxVariantProps) {
  const style = useStyle(rest);
  const Component = animatedStyle || entering || exiting ? Animated.View : View;

  return (
    <Component
      id={id}
      style={animatedStyle ? [style, animatedStyle] : style}
      entering={entering}
      exiting={exiting}
      onLayout={onLayout}
      renderToHardwareTextureAndroid={renderToHardwareTextureAndroid}
    >
      {children}
    </Component>
  );
}

export default memo(BoxDefault);
